import { arrayFrom, findElem, findElems, hasClass } from "@ts/utils/helpers";

const processProductPopup = (observer : MutationObserver, mutation : MutationRecord, doc : HTMLElement) : void => {
    const popup_el : HTMLElement = mutation.target as HTMLElement;

    if (mutation.type === 'attributes' && mutation.attributeName === 'class' && hasClass(popup_el, '_act')) {
        const user_info_el : HTMLElement | null   = findElem('.popup-product__user-info', popup_el);
        const form_bottom_el : HTMLElement | null = findElem('.popup-product__form-bottom', popup_el);

        if (!user_info_el || !form_bottom_el) {
            return;
        }

        const user_info_el_height : number | undefined   = user_info_el.offsetHeight;
        const form_bottom_el_height : number | undefined = form_bottom_el.offsetHeight;

        if (user_info_el_height) {
            doc.style.setProperty('--user-info-el-height', `${user_info_el_height}px`);
            doc.style.setProperty('--form-bottom-el-height', `${form_bottom_el_height}px`);

            observer.disconnect();
        }
    }
}

const fireProductPopup = (doc : HTMLElement, popup_product : HTMLElement) : void => {
    const observer = new MutationObserver((mutations : MutationRecord[]) : void => {
        mutations.forEach((mutation : MutationRecord) : void => {
            processProductPopup(observer, mutation, doc);
        });
    });

    observer.observe(popup_product, {
        attributes:      true,
        attributeFilter: ['class']
    });
}

const processProductsOnThankYouPage = (doc : HTMLElement) : void => {
    const prods_list_els : HTMLElement[] | [] = arrayFrom(findElems('.success__product'));
    const prods_list_els_length : number = prods_list_els.length;
    const prods_list_els_height : number = prods_list_els_length > 0 ? prods_list_els[0].offsetHeight : 0;
    let total_height : number;

    if (prods_list_els_length == 1) {
        total_height = prods_list_els_height;
    } else {
        total_height = prods_list_els_height * 2.3;
    }

    if (total_height > 0) {
        doc.style.setProperty('--success-product-height', `${total_height}px`);
    }
};

/**
 * CSS variables module
 */
export default () : void => {
    const doc : HTMLElement = document.documentElement;

    const init = () : void => {
        const header_element : HTMLElement | null = findElem('.header');
        const header_height : number | undefined  = header_element?.offsetHeight;

        doc.style.setProperty('--vh', `${window.innerHeight}px`);

        if (header_height) {
            doc.style.setProperty('--header-height', `${header_height}px`);
        }

        // Watch for class changes on .popup-product
        const popup_product = findElem('.popup-product');

        if (popup_product) {
            // Need for calculate height for .popup-product__products-list element
            fireProductPopup(doc, popup_product);
        }

        processProductsOnThankYouPage(doc);
    };

    init();

    window.addEventListener('resize', init);
};